import { render, staticRenderFns } from "./lkuDebitur.vue?vue&type=template&id=7285f310&"
import script from "./lkuDebitur.vue?vue&type=script&lang=js&"
export * from "./lkuDebitur.vue?vue&type=script&lang=js&"
import style0 from "./lkuDebitur.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports